import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=3af478e8&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=ts&"
export * from "./AddressList.vue?vue&type=script&lang=ts&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=3af478e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af478e8",
  null
  
)

export default component.exports